export const ATLASSIAN_HOME_URL = 'https://home.atlassian.com';
export const ATLASSIAN_HOME_URL_STAGING = 'https://home.stg.atlassian.com';
